export const MESSAGES = {
    VALIDATION_ERROR: "Please select a training.",
    DUPLICATE_TRAINING: (name) => `You are already enrolled in the ${name} training.`,
    ADD_SUCCESS: "Training added successfully!",
    ADD_ERROR: "Unable to add the training. Please try again later.",
    DELETE_SUCCESS: "The training has been deleted successfully.",
    DELETE_ERROR: "Unable to delete the training.",
    FETCH_USER_ERROR: "Failed to fetch user information.",
  };
  